import { Spin } from 'antd';
import { useLeadershipTier } from '@/hooks/useLeadershipTier';
import { LeaderProjectsMyListPage } from '@/pages/mobile/leader/LeaderProjectsMyListPage';
import { TopLeaderProjectOversightPage } from '@/pages/mobile/leader/TopLeaderProjectOversightPage';

export function LeaderProjectsPage() {
  const { isTopLeader, loading } = useLeadershipTier();

  if (loading) {
    return (
      <div className="mobile-card" style={{ textAlign: 'center', padding: 24 }}>
        <Spin />
      </div>
    );
  }

  if (isTopLeader) {
    return <TopLeaderProjectOversightPage />;
  }

  return <LeaderProjectsMyListPage />;
}
